/**
 * Environment detection utilities for SSR/CSR compatibility
 */

/**
 * Check if code is running in browser environment
 */
export const isBrowser = typeof window !== 'undefined'

/**
 * Check if code is running in server environment
 */
export const isServer = typeof window === 'undefined'

/**
 * Safely execute code only on client-side
 */
export const clientOnly = <T>(fn: () => T, fallback?: T): T | undefined => {
  if (isBrowser) {
    try {
      return fn()
    } catch (error) {
      console.warn('Client-only function execution failed:', error)
      return fallback
    }
  }
  return fallback
}

/**
 * Safely access window object
 */
export const safeWindow = isBrowser ? window : undefined

/**
 * Safely access document object
 */
export const safeDocument = isBrowser ? document : undefined

/**
 * Get user agent safely
 */
export const getUserAgent = (): string => {
  return clientOnly(() => navigator.userAgent, '') || ''
}

/**
 * Check if running in development mode
 */
export const isDevelopment = process.env.NODE_ENV === 'development'

/**
 * Check if running in production mode
 */
export const isProduction = process.env.NODE_ENV === 'production'

/**
 * Get the current deployment stage from STAGE env var
 */
export const getCurrentStage = (): string => {
  return process.env.STAGE?.trim().toLowerCase() || 'dev'
}

/**
 * Check if current deployment stage matches the expected stage
 */
export const isCurrentStage = (stage: string): boolean => {
  return getCurrentStage() === stage.trim().toLowerCase()
}
